export default {
 maxCasbackAmount:100,
 minCasbackAmount:1
}


// WEBPACK FOOTER //
// ./src/components/application/Cashback/CashbackAmountValidation.js